import { Loc } from "App/Loc";
import useFetchAllEvents from "../../Hooks/useFetchAllEvents";
import { Box, HStack, Text, VStack } from "native-base";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import RenderFilters from "./RenderFilters";
import EventCard from "./EventCard";

const EntityEvents = ({ entity, allEventData }) => {
  const params = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const currentUser: any = useSelector((state: any) => state?.user?.user[0]);
  const { events, loading, error } = useFetchAllEvents(
    entity,
    entity?.id,
    allEventData,
  );
  console.log({ events, entity, params, location, currentUser }, "EntityEvent");
  const [eventData, setEventData] = React.useState<any>(events);
  const [allEvents, setAllEvents] = React.useState<any>(events);
  const [filteredEvents, setFilteredEvents] = React.useState<any>([]);
  const [eventType, setEventType] = useState("Current");
  const [isCalendarView, setIsCalenderView] = useState(true);
  const [categories, setCategories] = useState<any>([]);
  const [selectedFilter, setSelectedFilter] = useState("Current");

  useEffect(() => {
    setEventData(events);
    setAllEvents(events);

    const currentEvents = events?.filter(
      (ev) => !isCanceled(ev) && new Date(ev.end) >= new Date(),
    );

    setFilteredEvents(currentEvents);
    setSelectedFilter("Current");

    const uniqueCategories = [
      "Current",
      ...new Set(currentEvents.map((event) => event.linkType)),
    ];
    const past = events?.filter(
      (ev) => new Date(ev.end) < new Date() && !isCanceled(ev),
    );
    const canceled = events?.filter((ev) => isCanceled(ev));
    if (past?.length > 0) uniqueCategories.push("Past");
    if (canceled?.length > 0) uniqueCategories.push("Canceled");
    setCategories(uniqueCategories.filter(Boolean));
  }, [events, loading]);

  const isCanceled = (event: any) =>
    event?.data?.toLowerCase() === "canceled" ||
    event?.status?.toLowerCase() === "canceled";

  const handleFilters = (filter) => {
    try {
      setSelectedFilter(filter);
      setFilteredEvents([]);

      const now = new Date();
      let filteredEvents = [];

      switch (filter) {
        case "Past":
          filteredEvents = events.filter(
            (event) => new Date(event.end) < now && !isCanceled(event),
          );
          break;
        case "Canceled":
          filteredEvents = events.filter((event) => isCanceled(event));
          break;
        case "Current":
          filteredEvents = events?.filter(
            (event) => !isCanceled(event) && new Date(event.end) >= now,
          );
          break;
        default:
          filteredEvents = events.filter(
            (event) =>
              event.linkType === filter &&
              !isCanceled(event) &&
              new Date(event.end) >= now,
          );
          break;
      }

      setFilteredEvents(filteredEvents);
    } catch (e) {
      console.error("Error in filtering the results", e);
    }
  };

  const handleEventClick = (item) => {
    try {
      console.log("handlenavigate", item);
      navigate(`/Events/${item?.id}/${item?.region}/${item?.seriesId}`, {
        state: { team: item, seriesId: item?.seriesId },
      });
    } catch (e) {
      console.log("Error in opening the Event", e);
    }
  };

  return (
    <VStack width={"100%"}>
      <HStack zIndex={-3} width="98%">
        <HStack
          marginY="24px"
          //overflowX={isMobile ? "scroll" : undefined}
          backgroundColor="rgba(0,0,0,0.05)"
          borderRadius="18px"
          minWidth={"40px"}
          maxWidth={"500px"}
          left="20px"
          height="36px"
        >
          {categories?.length > 0 && (
            <RenderFilters
              categories={categories}
              selectedFilter={selectedFilter}
              handleFilters={handleFilters}
            />
          )}
        </HStack>
      </HStack>

      <HStack width="100%" flexWrap={"wrap"} justifyContent={"flex-start"}>
        {filteredEvents?.length > 0 &&
          [...filteredEvents]?.map((item, index) => {
            return (
              <Box key={index}>
                <EventCard
                  item={item}
                  handleEventClick={handleEventClick}
                  isShowRSVP={false}
                />
              </Box>
            );
          })}
      </HStack>

      {filteredEvents?.length === 0 && (
        <VStack alignItems={"center"} justifyContent={"center"} height={200}>
          <Text bold>{Loc.currentLang.menu.noEventsFound}</Text>
        </VStack>
      )}
    </VStack>
  );
};

export default EntityEvents;
